import React from 'react';
import PropTypes from 'prop-types';

export default function Button({
  isSubmit,
  variant,
  label,
  className,
  onClick,
}) {
  let defaultClass = `flex items-center justify-center gap-y-2 rounded-lg py-3 px-4 text-sm outline-none whitespace-nowrap ${className} `;
  const primaryClass = `text-white bg-cyan-500 dark:bg-cyan-700 hover:bg-cyan-600 dark:hover:bg-cyan-600 focus-visible:bg-cyan-600 dark:focus-visible:bg-cyan-600`;
  const secondaryClass = `text-cyan-500 dark:text-cyan-600 hover:text-white dark:hover:text-white border border-cyan-500 dark:border-cyan-600 hover:bg-cyan-600 dark:hover:bg-cyan-600 focus-visible:bg-cyan-600 dark:focus-visible:bg-cyan-600`;
  const tertiaryClass = `hover:text-cyan-600 dark:hover:text-cyan-600 focus-visible:text-cyan-600 dark:focus-visible:text-cyan-600`;

  if (variant === 'tertiary') {
    defaultClass += tertiaryClass;
  } else if (variant === 'secondary') {
    defaultClass += secondaryClass;
  } else {
    defaultClass += primaryClass;
  }

  return (
    <button
      type={isSubmit ? 'submit' : 'button'}
      className={defaultClass}
      onClick={onClick}>
      {label}
    </button>
  );
}

Button.propTypes = {
  /** Type of button [submit or button] */
  isSubmit: PropTypes.bool,
  /** Variant of button */
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  /** Label of button */
  label: PropTypes.string.isRequired,
  /** Additional class */
  className: PropTypes.string,
  /** Click action */
  onClick: PropTypes.func,
};

Button.defaultProps = {
  isSubmit: false,
  variant: 'primary',
  className: '',
  onClick: undefined,
};
